import _getOr from "lodash/fp/getOr";
import { Paths } from "type-fest";

import { SupportedLocale } from "@intocare/datatypes/lib/i18n";
import domainCodesFrTranslations from "@intocare/domain-l10n/lib/domain-codes/fr.json";
import domainCodesNlTranslations from "@intocare/domain-l10n/lib/domain-codes/nl.json";
import domainModelFrTranslations from "@intocare/domain-l10n/lib/domain-model/fr.json";
import domainModelNlTranslations from "@intocare/domain-l10n/lib/domain-model/nl.json";

import featurePdfGenerationFrTranslations from "../../../i18n/fr.json";
import featurePdfGenerationNlTranslations from "../../../i18n/nl.json";

type Translations = typeof domainCodesNlTranslations
	& typeof domainModelNlTranslations
	& typeof featurePdfGenerationNlTranslations;

export interface DocumentContext {
	locale: SupportedLocale;
	t: (key: Paths<Translations, { leavesOnly: true }>, interpolate?: Record<string, string>) => string;
	upperCase: (value: string) => string;
}

const DOCUMENT_TRANSLATIONS: Record<SupportedLocale, Translations> = {
	"nl-BE": { ...domainCodesNlTranslations, ...domainModelNlTranslations, ...featurePdfGenerationNlTranslations },
	"fr-BE": { ...domainCodesFrTranslations, ...domainModelFrTranslations, ...featurePdfGenerationFrTranslations },
} as const;

export function createDocumentContextFor(options: { locale: SupportedLocale }): DocumentContext {
	return {
		locale: options.locale,
		t: (key, interpolate?) => {
			const translation = _getOr("", key, DOCUMENT_TRANSLATIONS[options.locale]) as string;

			return interpolate
				? translation.replace(/{{(.*?)}}/g, (_, placeholder) => _getOr("", placeholder, interpolate))
				: translation;
		},
		upperCase: (value: string) => value.toLocaleUpperCase(options.locale),
	};
}
